import { FC, memo } from 'react';

import DefaultCatalog, { DefaultCatalogProps } from '@Components/DefaultCatalog';
import useInfinitePromoCategory from '@Queries/useInfinitePromoCategory';

export type DynamicPromoCatalogProps = Omit<DefaultCatalogProps, 'category'>;

const DynamicPromoCatalog: FC<DynamicPromoCatalogProps> = (props) => {
  const { slug, ...restProps } = props;
  const category = useInfinitePromoCategory({ slug });

  return <DefaultCatalog {...restProps} category={category} slug={slug} />;
};

export default memo(DynamicPromoCatalog);
